import { render, staticRenderFns } from "./TeamMatches.vue?vue&type=template&id=f8d9cbf2&scoped=true"
import script from "./TeamMatches.vue?vue&type=script&lang=js"
export * from "./TeamMatches.vue?vue&type=script&lang=js"
import style0 from "./TeamMatches.vue?vue&type=style&index=0&id=f8d9cbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d9cbf2",
  null
  
)

export default component.exports